import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://suvkcsokdqqbiyyhdogr.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN1dmtjc29rZHFxYml5eWhkb2dyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUyNDcxMDEsImV4cCI6MjA5MDgyMzEwMX0.NxzlcpfjDnt0eLxzT2jdxIj65qB6-AEAWRY5xKKqGGk'

export const supabase = createClient(supabaseUrl, supabaseKey)